import React, { useState, useEffect } from 'react';
import { Label, FormGroup, Input, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import AddButton from '../../assets/img/Group_1383@2x.png';
import DeleteButton from '../../assets/svgs/TrashSimple.svg';

const LineItems = ({ title, items, setItems, itemsErrorArray, setItemsErrorArray, pickList1, pickList2, forceExpandAll }) => {
    const [showSuggestions, setShowSuggestions] = useState(new Array(items.length).fill(false));
    const [wholePickList, setWholePickList] = useState([]);
    const [expanded, setExpanded] = useState(new Array(items.length).fill(false));

    useEffect(() => {
        setWholePickList(
            Array.from(
                new Set(
                    [...pickList1, ...pickList2]
                        .filter(pick => {
                            return pick.detail !== '';
                        })
                        .map(pi => pi.detail)
                )
            )
        );
    }, [pickList1, pickList2]);

    useEffect(() => {
        setExpanded(expanded => {
            if (items.length > expanded.length) {
                return [...expanded, ...new Array(items.length - expanded.length).fill(false)];
            } else if (items.length < expanded.length) {
                return expanded.slice(0, items.length);
            }
            return expanded;
        });
    }, [items.length]);

    useEffect(() => {
        if (forceExpandAll) {
            setExpanded(new Array(items.length).fill(true));
        }
    }, [forceExpandAll, items.length]);

    const selectItem = (e, index, indexAutofill) => {
        const selectedPick = [...pickList1, ...pickList2].find(pick => pick.detail === wholePickList[indexAutofill]) || {};
        setItems(
            items.map((pi, i) => {
                return i === index
                    ? {
                          ...pi,
                          detail: wholePickList[indexAutofill],
                          unit: selectedPick.unit || pi.unit,
                          weight: selectedPick.weight || pi.weight,
                          length: selectedPick.length || pi.length,
                          width: selectedPick.width || pi.width,
                          height: selectedPick.height || pi.height,
                          nmfc: selectedPick.nmfc || pi.nmfc
                      }
                    : pi;
            })
        );
        setShowSuggestions(showSuggestions.map((suggestion, i) => (i === index ? false : suggestion)));
    };

    return (
        <>
            <Row form={true} style={{ paddingTop: 0 }}>
                <Col style={{ textAlign: 'left', marginBottom: '5px' }}>
                    <Label for="LineItems" style={{ fontSize: '1.1em' }}>
                        {title}
                    </Label>
                </Col>
            </Row>
            {items.length > 0 &&
                items.map((item, index) => {
                    return (
                        <React.Fragment key={item.id || item.item_id || `line-item-${index}`}>
                            <Row id={'lineItem-' + index}>
                                <Col
                                    sm="0.5"
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', cursor: 'pointer', paddingRight: 0 }}
                                    onClick={() => setExpanded(expanded.map((v, i) => (i === index ? !v : v)))}
                                >
                                    <span style={{ fontSize: 25, userSelect: 'none', color: '#fff', marginLeft: 15, marginBottom: 4, transform: 'scaleX(1.5)' }}>
                                        {expanded[index] ? '˄' : '˅'}
                                    </span>
                                </Col>
                                <Col sm="1.5" style={{ textAlign: 'left', marginLeft: '0px' }}>
                                    <Label for="pickupItems" style={{ marginTop: '8px', fontWeight: 'bold', marginLeft: '15px', fontSize: '1em' }}>
                                        Item Name
                                    </Label>
                                </Col>
                                <Col sm="5">
                                    <FormGroup style={{ width: '100%' }}>
                                        <ListGroup>
                                            <Input
                                                placeholder="ie. name, model number, description..., etc"
                                                onChange={e => {
                                                    setItems(
                                                        items.map((pi, i) => {
                                                            return i === index ? { ...item, detail: e.target.value } : pi;
                                                        })
                                                    );
                                                }}
                                                type="text"
                                                style={{ WebkitAppearance: 'none' }}
                                                value={items[index].detail}
                                                onClick={e => {
                                                    if (wholePickList.length > 0) {
                                                        setShowSuggestions(showSuggestions.map((suggestion, i) => (i === index ? true : false)));
                                                    } else {
                                                        setShowSuggestions(new Array(items.length).fill(false));
                                                    }
                                                }}
                                            />
                                            {title === 'Drop off Item(s)' && showSuggestions[index]
                                                ? wholePickList.map((pick, indexAutofill) => {
                                                      return (
                                                          <ListGroupItem
                                                              style={{ backgroundColor: '#1e1e2b', border: 'none', color: '#cbcac9' }}
                                                              key={indexAutofill}
                                                              onMouseOver={e =>
                                                                  (e.target.style.background = 'linear-gradient(90deg, hsla(218, 100%, 42%, 0.6) 0%, hsla(0, 0%, 98%, 1) 200%)')
                                                              }
                                                              onMouseLeave={e => (e.target.style.background = '#1e1e2b')}
                                                              onClick={e => selectItem(e, index, indexAutofill)}
                                                          >
                                                              {pick}
                                                          </ListGroupItem>
                                                      );
                                                  })
                                                : null}
                                        </ListGroup>
                                    </FormGroup>

                                    <div hidden={!(itemsErrorArray[index] && itemsErrorArray[index].detail)}>
                                        <p style={{ color: 'red', marginTop: '4px', marginBottom: '10px' }}>Item Detail is required</p>
                                    </div>
                                </Col>
                                <Col sm="1" style={{ textAlign: 'center' }}>
                                    <Label for="LineItems" style={{ marginTop: '8px', fontSize: '1em' }}>
                                        Quantity
                                    </Label>
                                </Col>
                                <Col sm="1">
                                    <FormGroup style={{ width: '110%' }}>
                                        <Input
                                            placeholder="1"
                                            onChange={e => {
                                                setItems(
                                                    items.map((pi, i) => {
                                                        return i === index ? { ...item, quantity: Number(e.target.value), _modified: true } : pi;
                                                    })
                                                );
                                            }}
                                            type="number"
                                            min="1"
                                            style={{ WebkitAppearance: 'none' }}
                                            value={items[index].quantity}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm="0.8" style={{ textAlign: 'left', marginLeft: '35px' }}>
                                    <Label for="LineItems" style={{ marginTop: '8px', fontSize: '1em' }}>
                                        Unit
                                    </Label>
                                </Col>
                                <Col sm="1">
                                    <FormGroup style={{ width: '110%' }}>
                                        <Input
                                            type="select"
                                            value={item.unit}
                                            onChange={e => {
                                                setItems(
                                                    items.map((pi, i) => {
                                                        return i === index ? { ...item, unit: e.target.value } : pi;
                                                    })
                                                );
                                            }}
                                            style={{
                                                height: '38px', // Explicit height to ensure no cut-off
                                                lineHeight: '1.2', // Ensures content is vertically centered
                                                padding: '0 2px', // Consistent padding with quantity input
                                                verticalAlign: 'middle', // Ensures input is vertically aligned with label
                                                marginTop: '-3px', // Move input box up (negative margin to reduce space)
                                                border: !item.unit ? '1px solid red' : null // Red border if no unit selected
                                            }}
                                        >
                                            <option value="" disabled hidden>
                                                Select one
                                            </option>
                                            <option value="Items">Items</option>
                                            <option value="Units">Units</option>
                                            <option value="Pallets">Pallets</option>
                                            <option value="Boxes">Boxes</option>
                                            <option value="Bundles">Bundles</option>
                                            <option value="Cartons">Cartons</option>
                                            <option value="Crates">Crates</option>
                                            <option value="Drums">Drums</option>
                                            <option value="Rolls">Rolls</option>
                                            <option value="Totes">Totes</option>
                                        </Input>
                                        <div hidden={!(itemsErrorArray[index] && itemsErrorArray[index].unit)}>
                                            <p style={{ color: 'red', marginTop: '4px', marginBottom: '10px' }}>Unit is required</p>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col sm="1">
                                    {/* <div style={{ opacity: 0 }}>Q</div> */}
                                    <div style={{ textAlign: 'right', verticalAlign: 'middle', marginTop: '4px', width: '50%' }}>
                                        <img
                                            alt="add"
                                            style={{ cursor: 'pointer', width: 25, height: 25, verticalAlign: 'middle' }}
                                            src={AddButton}
                                            onClick={() => {
                                                setItems([...items, { quantity: 1, detail: '', unit: '', weight: 1, length: 1, width: 1, height: 1, nmfc: '' }]);
                                                setItemsErrorArray([...itemsErrorArray, { detail: false, unit: false }]);
                                                setShowSuggestions([...showSuggestions, false]);
                                            }}
                                        />
                                    </div>
                                </Col>
                                <Col sm="0.7">
                                    {/* <div style={{ opacity: 0 }}>Q</div> */}
                                    <div style={{ textAlign: 'left', verticalAlign: 'middle', marginTop: '6px', marginLeft: '0px' }}>
                                        {items.length > 1 && (
                                            <img
                                                alt="delete"
                                                style={{ cursor: 'pointer', width: 20, height: 20, verticalAlign: 'middle' }}
                                                src={DeleteButton}
                                                onClick={() => {
                                                    setItems(
                                                        items.filter((item, i) => {
                                                            return i !== index;
                                                        })
                                                    );
                                                    setItemsErrorArray(
                                                        itemsErrorArray.filter((item, i) => {
                                                            return i !== index;
                                                        })
                                                    );
                                                    setShowSuggestions(
                                                        showSuggestions.filter((suggestion, i) => {
                                                            return i !== index;
                                                        })
                                                    );
                                                }}
                                            />
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            {expanded[index] && (
                                <Row style={{ marginBottom: '30px', marginLeft: '16px' }}>
                                    <Col sm="1">
                                        <Label for="weight" style={{ marginTop: '8px', fontSize: '1em' }}>
                                            Weight (lbs)
                                        </Label>
                                    </Col>
                                    <Col sm="1">
                                        <Input
                                            type="number"
                                            placeholder="1"
                                            value={item.weight}
                                            onChange={e => {
                                                setItems(items.map((pi, i) => (i === index ? { ...item, weight: Number(e.target.value), _modified: true } : pi)));
                                            }}
                                            min="1"
                                        />
                                    </Col>
                                    <Col sm="1">
                                        <Label for="length" style={{ marginTop: '8px', fontSize: '1em' }}>
                                            Length (in)
                                        </Label>
                                    </Col>
                                    <Col sm="1">
                                        <Input
                                            type="number"
                                            placeholder="1"
                                            value={item.length}
                                            onChange={e => {
                                                setItems(items.map((pi, i) => (i === index ? { ...item, length: Number(e.target.value) } : pi)));
                                            }}
                                            min="1"
                                        />
                                    </Col>
                                    <Col sm="1">
                                        <Label for="width" style={{ marginTop: '8px', fontSize: '1em' }}>
                                            Width (in)
                                        </Label>
                                    </Col>
                                    <Col sm="1">
                                        <Input
                                            type="number"
                                            placeholder="1"
                                            value={item.width}
                                            onChange={e => {
                                                setItems(items.map((pi, i) => (i === index ? { ...item, width: Number(e.target.value) } : pi)));
                                            }}
                                            min="1"
                                        />
                                    </Col>
                                    <Col sm="1">
                                        <Label for="height" style={{ marginTop: '8px', fontSize: '1em' }}>
                                            Height (in)
                                        </Label>
                                    </Col>
                                    <Col sm="1">
                                        <Input
                                            type="number"
                                            placeholder="1"
                                            value={item.height}
                                            onChange={e => {
                                                setItems(items.map((pi, i) => (i === index ? { ...item, height: Number(e.target.value) } : pi)));
                                            }}
                                            min="1"
                                        />
                                    </Col>
                                    <Col sm="1" style={{ textAlign: 'left' }}>
                                        <Label for="nfmc" style={{ marginTop: '8px', fontSize: '1em' }}>
                                            NMFC
                                        </Label>
                                    </Col>
                                    <Col sm="1.5">
                                        <FormGroup style={{ width: '80%', marginLeft: '-25px' }}>
                                            <Input
                                                type="text"
                                                placeholder="#29250"
                                                value={item.nmfc}
                                                onChange={e => {
                                                    setItems(items.map((pi, i) => (i === index ? { ...item, nmfc: e.target.value } : pi)));
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            )}
                            {index < items.length - 1 && <hr style={{ borderColor: '#344675', borderStyle: 'solid' }} />}
                        </React.Fragment>
                    );
                })}
        </>
    );
};

export default LineItems;
